import * as React from "react";
import { useCallback, useMemo } from "react";
import { CallParticipantList } from "../CallParticipantList";
import { fillWidthStyles, SidepaneItem, useCallAdapter } from "live-lesson/shared/feature-call-ui-react";
import { ParticipantsButton, toFlatCommunicationIdentifier, usePropsFor } from "@azure/communication-react";
import { CallParticipantListSearchBox } from "../CallParticipantListSearchBox";
import { InputOnChangeData, SearchBoxChangeEvent } from "@fluentui/react-components";
import { mergeStyles } from "@fluentui/react";
import { CreateMenuItemsCallbacks } from "../util/createMenuItems";


const searchBoxContainerStyles = mergeStyles({ marginTop: "12px" });


interface CallParticipantListSidePaneItemProps {
    isOpen: boolean;
    close?: () => void;
    isMobile: boolean;

    numTotalParticipants: number;
    menuItemCallbacks: CreateMenuItemsCallbacks;
}


export const CallParticipantListSidePaneItem = (props: CallParticipantListSidePaneItemProps): JSX.Element => {
    const participantsProps = usePropsFor(ParticipantsButton);

    const callAdapter = useCallAdapter();
    const callAdapterState = callAdapter.getState();
    const myUserId = useMemo(() => toFlatCommunicationIdentifier(callAdapterState.userId), [callAdapterState.userId]);

    const [searchValue, setSearchValue] = React.useState<string>('');
    const onSearchValueChange = useCallback((event: SearchBoxChangeEvent, data: InputOnChangeData) => {
        setSearchValue(data.value);
    }, []);

    const participants = participantsProps.participants;
    const filteredParticipants = useMemo(
        () => participants.filter(p => p.displayName?.toLocaleLowerCase()?.includes(searchValue.toLocaleLowerCase())) || [],
        [participants, searchValue]
    );

    const participantsSidebarTitle = useMemo(
        () => (
            <>
                <div className={mergeStyles(fillWidthStyles)}>
                    <div>
                        Teilnehmer ({props.numTotalParticipants})
                    </div>
                    <div className={searchBoxContainerStyles}>
                        <CallParticipantListSearchBox onValueChange={onSearchValueChange} />
                    </div>
                </div>
            </>
        ),
        [props.numTotalParticipants]
    );

    return (
        <SidepaneItem
            isOpen={props.isOpen}
            close={props.close}
            headerText={participantsSidebarTitle}
            closeButtonText={"Schließen"}
        >
            <CallParticipantList
                participants={filteredParticipants}
                myUserId={myUserId}
                menuItemCallbacks={props.menuItemCallbacks}
            />
        </SidepaneItem>
    );
};
